import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ClipboardList, Package, Users, Plane, Shield, ClipboardCheck, ListChecks, Receipt } from "lucide-react";
import { Link } from "react-router-dom";

const modules = [
  { title: "Inventory & Signage", description: "Track equipment, banners, signage, and supplies for each event.", icon: Package, href: "/admin-dashboard/event-management/inventory", status: "Active" },
  { title: "Staffing", description: "Manage staff assignments, shifts, and availability for events.", icon: Users, href: "/admin-dashboard/event-management/staffing", status: "Active" },
  { title: "Travel", description: "Coordinate travel logistics, hotel blocks, and transportation.", icon: Plane, href: "/admin-dashboard/event-management/travel", status: "Active" },
  { title: "Officials", description: "Manage referee and official assignments, certifications, and payments.", icon: Shield, href: "/admin-dashboard/event-management/officials", status: "Active" },
  { title: "Scorekeepers", description: "Assign and manage scorekeepers across games and courts.", icon: ClipboardCheck, href: "/admin-dashboard/event-management/scorekeepers", status: "Active" },
  { title: "Checklists", description: "Pre-event, day-of, and post-event task checklists.", icon: ListChecks, href: "/admin-dashboard/event-management/checklists", status: "Active" },
  { title: "Expenses", description: "Track and categorize event expenses and budgets.", icon: Receipt, href: "/admin-dashboard/event-management/expenses", status: "Coming Soon" },
];

const EventManagementOverview: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <ClipboardList className="h-6 w-6 text-secondary" />
          Event Management
        </h1>
        <p className="text-muted-foreground mt-1">Central hub for all event operations — inventory, staffing, travel, officials, and more.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {modules.map((mod) => (
          <Link key={mod.title} to={mod.href}>
            <Card className="hover:shadow-md transition-shadow cursor-pointer h-full">
              <CardHeader className="pb-2">
                <CardTitle className="text-base flex items-center justify-between">
                  <span className="flex items-center gap-2">
                    <mod.icon className="h-5 w-5 text-primary" />
                    {mod.title}
                  </span>
                  <Badge variant={mod.status === "In Progress" ? "default" : "secondary"} className="text-xs">
                    {mod.status}
                  </Badge>
                </CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-sm text-muted-foreground">{mod.description}</p>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default EventManagementOverview;
